





























































































































































































































































































































import { Component, Vue, Prop, InjectReactive, Watch, Inject } from 'vue-property-decorator';
import { GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits, GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paychecks } from '@/queries/__generated__/paycheckDataForPaycheckListForm';
import { GQL_PaycheckDraftSave, GQL_PaycheckDraftLineSave } from '@/queries/global';
import { GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods } from '@/queries/__generated__/currentUnitPaycheckPeriods';
import PaycheckDraftPeriodFormPaycheckDraftLine from './PaycheckDraftPeriodFormPaycheckDraftLine.vue';
import clone from 'lodash/clone';
import PaycheckDraft from '@/app/PaycheckDraft';
import paycheckSettingsService from '@/utils/paycheck-settings-service';
import Altinn from '@/app/Altinn';
import { isEndedForPeriod, isNotStartedForPeriod } from '@/app/WorkRelation';
import PaycheckDraftPeriodFormDraftLineHeader from './PaycheckDraftPeriodFormDraftLineHeader.vue';
import { sumCorrectPaycheckLines } from '@/app/Paycheck';
import Decimal from '@/utils/decimal';
import { GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates} from '@/queries/__generated__/paycheckLineTemplates';
import { PaycheckLineTemplateMap } from './PaycheckDraftPeriodForm.vue';
import formatDateTime from '@/filters/formatDateTime';

export type StringBoolean = 'true' | 'false' | 'null';

@Component({
  components: {
    PaycheckDraftPeriodFormPaycheckDraftLine,
    PaycheckDraftPeriodFormDraftLineHeader,
  },
})
export default class PaycheckDraftPeriodFormWorkRelation extends Vue {
  @Prop({ type: Object, required: true }) private subUnit!: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits;
  @Prop({ type: Object, required: true }) private workRelation!: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations;
  @InjectReactive() private paycheckLineTemplatesMap!: PaycheckLineTemplateMap;
  @InjectReactive() private paycheckPeriod!: GQL_currentUnitPaycheckPeriods_currentUnit_paycheckPeriods;
  @InjectReactive() private formDirty!: boolean;
  @InjectReactive() private editable!: boolean;
  @Inject() private advancedPaycheckMode!: boolean;

  public expandMeOnSave = false;

  private expanded = false;
  private paycheckSettingsService = paycheckSettingsService;
  private Altinn = Altinn;
  private isEndedForPeriod = isEndedForPeriod;
  private isNotStartedForPeriod = isNotStartedForPeriod;
  private formatDateTime = formatDateTime;

  private created() {
    if (!this.currentPaycheckDraft && !this.workRelation.paychecks.length) {
      this.addPaycheckDraft(null);
    }

    this.expanded = paycheckSettingsService.isExpandedSection(this.paycheckPeriod.id, this.subUnit.id, this.workRelation.id);
  }

  public expand() {
    this.expanded = true;
  }

  private collapse() {
    this.expanded = false;
  }

  private get expandable() {
    return this.hasPaychecksThisMonthRadio === 'true';
  }

  private toggleExpanded() {
    if (!this.expandable) return;

    this.expanded = !this.expanded;
  }

  public get workRelationId() { return this.workRelation.id }

  @Watch('expanded')
  private onExpandChange(): void {
    paycheckSettingsService.expandSection(this.expanded, this.paycheckPeriod.id, this.subUnit.id, this.workRelation.id);
  }

  private addPaycheckDraft(active: boolean | null): void {
    this.workRelation.paycheckDrafts.push(
      PaycheckDraft.newDraft(
        this.workRelation.id,
        this.paycheckPeriod.id,
        active,
      ),
    );
  }

  private restorePaycheckDraft() {
    this.currentPaycheckDraft!.active = true;
  }

  private cancelPaycheckDraft() {
    this.currentPaycheckDraft!.active = false;
    if (!this.workRelation.paychecks.length) this.collapse();
  }

  public get currentPaycheckDraft(): GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts & GQL_PaycheckDraftSave | undefined {
    return this.workRelation.paycheckDrafts.find(paycheckDraft => !paycheckDraft.paycheck);
  }

  private get currentPaycheckDraftNotDeletedLines(): (GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines & GQL_PaycheckDraftLineSave)[] | undefined {
    if (!this.currentPaycheckDraft) return undefined;

    const sortMap: { [paycheckLineTemplateId: string]: number } =
      this.paycheckLineTemplatesMap[this.workRelationId]
        .reduce(
          (acc, t) => {
            if (t.mainPaycheckLineTemplate) acc[t.id] = t.mainPaycheckLineTemplate.number;
            return acc;
          },
          {} as { [paycheckLineTemplateId: string]: number },
        );

    return (this.currentPaycheckDraft.paycheckDraftLines as (GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines & GQL_PaycheckDraftLineSave)[])
      .filter(line => !line._destroy)
      .sort((line1, line2) =>
        !line1.paycheckLineTemplateId || !line2.paycheckLineTemplateId || line1.paycheckLineTemplateId === line2.paycheckLineTemplateId
          ? 0
          : sortMap[line1.paycheckLineTemplateId] - sortMap[line2.paycheckLineTemplateId]);
  }

  private get paycheckDraftLinesSum(): Decimal {
    const lines = this.currentPaycheckDraftNotDeletedLines;
    if (!lines) return new Decimal(0);

    const calculationLines = lines.map(line => {
      const template = this.paycheckLineTemplatesMap[this.workRelationId]
        .find(template => template.id === line.paycheckLineTemplateId);

      return {
        sum: line.sum,
        calculationType: template?.mainPaycheckLineTemplate?.calculationType,
      };
    });

    return sumCorrectPaycheckLines(calculationLines);
  }

  private addPaycheckDraftLine(
    event?: MouseEvent,
    paycheckLineTemplate?: GQL_paycheckLineTemplates_currentUnit_subUnits_workRelations_paycheckLineTemplates,
  ): void {
    this.currentPaycheckDraft!.paycheckDraftLines!.push({
      __typename: 'PaycheckDraftLine',
      id: null!,
      paycheckLineTemplate: paycheckLineTemplate || null,
      paycheckLineTemplateId: paycheckLineTemplate?.id || null,
      quantity: paycheckLineTemplate?.quantity || new Decimal(0),
      rate: paycheckLineTemplate?.rate || new Decimal(0),
      sum: paycheckLineTemplate?.sum || new Decimal(0),

      carOverwrite: paycheckLineTemplate?.carOverwrite || false,
      projectOverwrite: paycheckLineTemplate?.projectOverwrite || false,
      departmentOverwrite: paycheckLineTemplate?.departmentOverwrite || false,
      car: paycheckLineTemplate?.car || null,
      carId: paycheckLineTemplate?.car?.id || null,
      project: paycheckLineTemplate?.project || null,
      projectId: paycheckLineTemplate?.project?.id || null,
      department: paycheckLineTemplate?.department || null,
      departmentId: paycheckLineTemplate?.department?.id || null,
    } as GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines & GQL_PaycheckDraftLineSave);
  }

  private removePaycheckDraftLine(line: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts_paycheckDraftLines & GQL_PaycheckDraftLineSave): void {
    if (line.id) {
      this.$set(line, '_destroy', true);
    } else {
      this.currentPaycheckDraft!.paycheckDraftLines.splice(
        this.currentPaycheckDraft!.paycheckDraftLines.indexOf(line),
        1,
      );
    }
  }

  @Watch('currentPaycheckDraft.active', { immediate: true })
  private removePaycheckDraftLinesFromInactiveDraft(): void {
    if (!this.currentPaycheckDraft) return;

    if (this.currentPaycheckDraft.active && this.currentPaycheckDraftNotDeletedLines!.length === 0) {
      this.paycheckLineTemplatesMap[this.workRelationId]
        .filter(template =>
          !template.quantity.isZero() ||
          !template.rate.isZero() ||
          !template.sum.isZero() ||
           template.car ||
           template.project ||
           template.department,
        )
        .filter(template => template.active)
        .forEach(template => this.addPaycheckDraftLine(undefined, template));
    } else if (this.currentPaycheckDraft.active === false) {
      clone(this.currentPaycheckDraft.paycheckDraftLines).forEach(line => this.removePaycheckDraftLine(line));
    }

    this.$emit('work-relation-active-changed');
  }

  @Watch('hasPaychecksThisMonthRadio')
  private handlePaycheckThisMonthChange() {
    if (this.hasPaychecksThisMonthRadio) this.expandMeOnSave = true;
  }

  private get hasPaychecksThisMonth(): boolean {
    if (this.workRelation.paychecks.length) return true;

    if (this.currentPaycheckDraft) {
      return this.currentPaycheckDraft.active;
    } else {
      return false;
    }
  }

  private get hasPaychecksThisMonthRadio(): StringBoolean {
    return String(this.hasPaychecksThisMonth) as StringBoolean;
  }

  private set hasPaychecksThisMonthRadio(value: StringBoolean) {
    if (!this.currentPaycheckDraft) return;

    this.currentPaycheckDraft.active = value === 'true';
  }

  private paidOutAmount(paycheck: GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paychecks): Decimal {
    return sumCorrectPaycheckLines(paycheck.paycheckLines);
  }

  private get isMoreThanOneMonthInFuture(): boolean {
    return this.$dayjs(this.paycheckPeriod.bookkeepingPeriod, 'YYYY-MM', true).diff(this.$dayjs().format('YYYY-MM'), 'months') > 1;
  }
}
